<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de BPA consolidado">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/bpa/relatorio-bpa-consolidado/List'

export default {
    components: { List },
}
</script>